export default function hideSweetSpot(){
    this.dataSet("conf/popup/show", false);
    
    //this.dataSet("conf/sweetSpot/show", false);
    //this.dataSet("conf/sweetSpot/data", null);
}